import React, { useEffect } from 'react';
import { Grid, GridRow, GridColumn } from "semantic-ui-react";
import styles from './BillingInvoice.module.scss';
import {
    COMPANY_NAME, COMPANY_WWW,
    INVOICE_ACCOUNT, INVOICE_BANK, INVOICE_SWIFT, INVOICE_RECIPIENT, INVOICE_VAT_ID, INVOICE_REGISTRATION_ADDRESS,
    INVOICE_AMOUNT_BASIC_MONTH, INVOICE_AMOUNT_BASIC_MONTH_TEXT,
    INVOICE_AMOUNT_BASIC_YEAR, INVOICE_AMOUNT_BASIC_YEAR_TEXT,
    INVOICE_AMOUNT_STANDARD_MONTH, INVOICE_AMOUNT_STANDARD_MONTH_TEXT,
    INVOICE_AMOUNT_STANDARD_YEAR, INVOICE_AMOUNT_STANDARD_YEAR_TEXT,
    INVOICE_AMOUNT_PREMIUM_MONTH, INVOICE_AMOUNT_PREMIUM_MONTH_TEXT,
    INVOICE_AMOUNT_PREMIUM_YEAR, INVOICE_AMOUNT_PREMIUM_YEAR_TEXT
} from '../../../common/constants/company';
import HeaderInvoice from '../../../components/HeaderInvoice/HeaderInvoice';
import { useAppSelector } from "../../../hooks/hooks";
import { TBillingState } from "../Billing.interfaces";

const BillingInvoice: React.FC = () => {
    const billing: TBillingState = useAppSelector(state => state.Billing);
    useEffect(() => {
        document.title = COMPANY_NAME + ' - invoice';
    }, []);

    let amountText: string = INVOICE_AMOUNT_BASIC_MONTH_TEXT;
    let amount: number = INVOICE_AMOUNT_BASIC_MONTH;

    switch (billing.payOption) {
        case 'py':
            amount = INVOICE_AMOUNT_PREMIUM_YEAR;
            amountText = INVOICE_AMOUNT_PREMIUM_YEAR_TEXT;
            break;
        case 'pm':
            amount = INVOICE_AMOUNT_PREMIUM_MONTH;
            amountText = INVOICE_AMOUNT_PREMIUM_MONTH_TEXT;
            break;
        case 'sy':
            amount = INVOICE_AMOUNT_STANDARD_YEAR;
            amountText = INVOICE_AMOUNT_STANDARD_YEAR_TEXT;
            break;
        case 'sm':
            amount = INVOICE_AMOUNT_STANDARD_MONTH;
            amountText = INVOICE_AMOUNT_STANDARD_MONTH_TEXT;
            break;
        case 'by':
            amount = INVOICE_AMOUNT_BASIC_YEAR;
            amountText = INVOICE_AMOUNT_BASIC_YEAR_TEXT;
            break;
        case 'bm':
        default:
            amount = INVOICE_AMOUNT_BASIC_MONTH;
            amountText = INVOICE_AMOUNT_BASIC_MONTH_TEXT;
            break;
    }

    return (
        <div className={styles.container}>
            <HeaderInvoice />
            <Grid celled='internally'>
                <GridRow>
                    <GridColumn width={8} textAlign='right'>Account</GridColumn>
                    <GridColumn width={8} textAlign='left'>{INVOICE_ACCOUNT}</GridColumn>
                </GridRow>
                <GridRow>
                    <GridColumn width={8} textAlign='right'>Bank</GridColumn>
                    <GridColumn width={8} textAlign='left'>{INVOICE_BANK}</GridColumn>
                </GridRow>
                <GridRow>
                    <GridColumn width={8} textAlign='right'>SWIFT/BIC</GridColumn>
                    <GridColumn width={8} textAlign='left'>{INVOICE_SWIFT}</GridColumn>
                </GridRow>
                <GridRow>
                    <GridColumn width={8} textAlign='right'>Recipient</GridColumn>
                    <GridColumn width={8} textAlign='left'>{INVOICE_RECIPIENT}</GridColumn>
                </GridRow>
                <GridRow>
                    <GridColumn width={8} textAlign='right'>VAT ID</GridColumn>
                    <GridColumn width={8} textAlign='left'>{INVOICE_VAT_ID}</GridColumn>
                </GridRow>
                <GridRow>
                    <GridColumn width={8} textAlign='right'>Registration Address</GridColumn>
                    <GridColumn width={8} textAlign='left'>{INVOICE_REGISTRATION_ADDRESS}</GridColumn>
                </GridRow>
            </Grid>
            {billing.companyName ? <p>Customer  + company</p> : ''}

            <h2 className={styles.number}>Invoice {billing.invoiceNumber}</h2>
            <h4 className={styles.date}>{new Date(billing.invoiceDate).toLocaleDateString()}</h4>

            <Grid celled>
                <GridRow className={styles.header}>
                    <GridColumn width={2}>#</GridColumn>
                    <GridColumn width={10}>service</GridColumn>
                    <GridColumn width={4}>amount</GridColumn>
                </GridRow>
                <GridRow>
                    <GridColumn width={2} className={styles.counter}>1</GridColumn>
                    <GridColumn width={10}>{COMPANY_WWW} access</GridColumn>
                    <GridColumn width={4} className={styles.amount}>{amount} EUR</GridColumn>
                </GridRow>
                <GridRow className={styles.total}>
                    <GridColumn width={12}>total</GridColumn>
                    <GridColumn width={4}>{amount} EUR</GridColumn>
                </GridRow>
            </Grid>

            <p className={styles.amountText}>{amountText} euros</p>

            <div className={styles.footer}>
                <p>Signature: __________ / __________</p>
            </div>
        </div>
  );
}

export default BillingInvoice;